<template>
    <v-dialog v-model="abrirDialog" max-width="650px" class="pa-5" persistent>
        <v-card>
            <v-btn icon class="close-btn-att" @click="fecharDialog()">
                <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-card-title class="headline font-weight-bold text-h5">
                Atualização {{ versaoAtual ? `v${versaoAtual}` : 'Disponível' }}
            </v-card-title>

            <v-card-text v-if="carregando">
                <p>Carregando atualizações...</p>
                <v-progress-circular indeterminate color="primary" />
            </v-card-text>

            <v-card-text v-else class="pb-0">
                <p>
                    Caro parceiro, a <strong>plataforma de vendas foi atualizada!</strong>
                </p>

                <section class="mt-4">
                    <p>Nessa versão, foram implementadas as <strong>seguintes melhorias:</strong></p>
                    <ul v-if="melhorias.length">
                        <li v-for="(melhoria, index) in melhorias" :key="index">
                            {{ melhoria }}
                        </li>
                    </ul>
                    <p v-else class="font-italic">
                        Nenhuma melhoria registrada nesta versão.
                    </p>
                </section>

                <p class="mt-4">
                    <strong>Caso encontre algum erro</strong>, pedimos que <strong>entre em contato com a Área de Suporte</strong> para que possamos corrigi-lo o mais rápido possível.
                </p>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="fecharDialog()">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'DialogAtualizacaoDaVersao',
    props: {
      value: {
        type: Boolean,
        required: true
      }
    },
    data () {
      return {
        abrirDialog: false,
        carregando: true,
        versaoAtual: null,
        melhorias: []
      }
    },
    mounted () {
      setTimeout(async () => {
        await this.buscarChangelogs()
      }, 500)
    },
    methods: {
      async buscarChangelogs () {
        try {
          this.carregando = true

          const id_usuario = this.$session.get('id_usuario_interno')
          const sessaoPainel = this.$session.get('sessao_painel')

          const rota = sessaoPainel
            ? `/atualizacaoversaopainel/${id_usuario}`
            : `/atualizacaoversao/${id_usuario}`

          const response = await this.$http.get(rota, {
            headers: {
              'X-Atualizacao-Valida': 'true'
            }
          })

          if (response.data.exibirModalAtualizacao) {
            this.versaoAtual = response.data.versao || null
            this.melhorias = response.data.melhorias || []
            this.abrirDialog = true
          }
        } catch (error) {
          console.error('Erro ao buscar changelogs:', error)
        } finally {
          this.carregando = false
        }
      },
      fecharDialog () {
        this.abrirDialog = false
        this.$emit('input', false)
      }
    }
  }
</script>

<style scoped>
.close-btn-att {
  position: absolute;
  top: 16px;
  right: 16px;
}
.mt-4 {
  margin-top: 1rem;
}
</style>
